import type { Account } from '@/lib/data/domains/account';
import type { ChangePassword, User } from '@/lib/data/domains/user';
import { type CRUDResponse } from '@/lib/data/shared';
import { restService } from '@/lib/utils';

export type AccountCRUDService = {
  fetchUser: ({
    requestInit,
  }: {
    requestInit?: RequestInit;
  }) => Promise<CRUDResponse<User>>;
  updateDetails: ({
    payload,
    requestInit,
  }: {
    payload: Account;
    requestInit?: RequestInit;
  }) => Promise<CRUDResponse<User>>;
  changePassword: ({
    payload,
    requestInit,
  }: {
    payload: ChangePassword;
    requestInit?: RequestInit;
  }) => Promise<CRUDResponse<void>>;
};

export const accountRestStorage: AccountCRUDService = {
  fetchUser: async ({ requestInit }) =>
    restService.request({
      url: `/account/me`,
      requestInit,
    }),
  updateDetails: async ({ payload, requestInit }) =>
    restService.request({
      url: `/account/update-my-details`,
      method: 'PUT',
      body: payload,
      requestInit,
    }),
  changePassword: async ({ payload, requestInit }) =>
    restService.request({
      url: `/account/changepassword`,
      method: 'PUT',
      body: payload,
      requestInit,
    }),
};
